/* eslint-disable ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, warp-drive/no-legacy-request-patterns */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { uniqBy, mapBy, alias } from '@ember/object/computed';
import { service } from '@ember/service';
import GoalState from '@linc-technologies/linced-common/enums/goal-state';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';
import moment from 'moment';

export default class SubjectController extends Controller {
  queryParams = [
    {
      currentTab: { as: 'subject-currentTab' },
    },
  ];

  // Services
  @service
  options;

  @service
  session;

  @service
  store;

  @alias('model.group.currentLearners.length')
  numLearners;

  @alias('model.group.id')
  groupId;

  @optionAlias('hero:lock:milestones')
  milestonesLocked;

  @uniqBy('model.states', 'goal_id')
  uniqueGoals;

  @mapBy('uniqueGoals', 'goal')
  currentGoals;

  @computed('currentGoals.[]', 'model.states.[]')
  get goals() {
    return this.currentGoals.reduce((map, goal) => {
      let goalId = goal.get('id');
      let data = {
        goalId,
        developing: this.model.states.filter((item) => item.goal_id === goalId),
        secure: this.store.query('goals/state', {
          goalId: goalId,
          groupId: this.groupId,
          current: true,
          awarded: GoalState.SECURE,
        }),
      };

      map.push(data);

      return map;
    }, []);
  }

  // peak time definitions
  nowInterval = moment.duration(1, 'minutes');

  peakInterval = moment.duration(1, 'hours');
  peakFormat = 'HH:mm';
  peakPrecision = 'minute';
  morningPeakStart = '08:45';
  morningPeakEnd = '09:15';

  @tracked
  goalDialogOpen;

  @tracked
  selectedGoal;

  @tracked
  selectedGoalStates;

  @action
  openGoalDialog(goal) {
    this.selectedGoal = goal;
    this.selectedGoalStates = this.store.query('goals/state', {
      groupId: this.groupId,
      goalId: goal.get('id'),
      current: true,
    });
    this.goalDialogOpen = true;
  }

  @action
  closeGoalDialog() {
    this.goalDialogOpen = false;
    this.model.states.update();
  }
}
